function isBoneSprinklered(bone, aggConfig) {
  const maxFfl = (bone.floors - 1) * aggConfig.f2fHeight;
  const { sprinkleredFflThreshold } = aggConfig;
  return maxFfl >= sprinkleredFflThreshold;
}
export {
  isBoneSprinklered
};
//# sourceMappingURL=index117.js.map
